export default "__VITE_ASSET__sOGVc17B__";